<template>
    <div class="h-100">
        <section class="section h-100 p-0">
                <div class="row justify-content-center h-100 " style="overflow-x: hidden;">
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 border-lg-right section-lg pt-lg-5 pr-lg-0" style="background:rgb(255, 255, 255);">
                        <div class="row">
                            <div class="col-md-4"></div>
                            <div class="col-md-7">
                                <div class="container">
                                    <span class="h1">{{$route.params.storeName}}</span>
                                    <nav v-if="step!=4 && step!=5">
                                        <ol class="breadcrumb bg-white pl-0">
                                            <li class="breadcrumb-item">
                                                <a class="text-primary" role="button" @click.prevent="backToCart">Cart</a>
                                            </li>
                                            <li class="breadcrumb-item">
                                                <span v-if="!infoStatus" >Information</span>
                                                <a v-else class="text-primary" role="button" @click.prevent="information">Information</a>
                                            </li>
                                            <li class="breadcrumb-item" v-bind:class="{ active: ShipStatus==null }">
                                                <span v-if="!ShipStatus">Shipping</span>
                                                <a v-else class="text-primary" role="button" @click.prevent="shipping">Shipping</a>
                                            </li>
                                            <li class="breadcrumb-item" v-bind:class="{ active: paymentStatus==null }">
                                                <span v-if="!paymentStatus">Payment</span>
                                                <a v-else class="text-primary" role="button" @click.prevent="payment">Payment</a>
                                            </li>
                                        </ol>
                                    </nav>
                                    <base-alert v-if="errors.length" type="danger">
                                        <b>You have the following error(s):</b>
                                        <li v-for="error in errors" :key="error">{{ error }}</li>
                                    </base-alert>
                                    <a-spin :spinning="paymentStatusLoading" >
                                        <div class="row" v-if="step==1">
                                            <div class="col-md-12" v-if="infomationStatus == 1">
                                                <label class="form-control-label">
                                                    Contact information
                                                    <span v-if="loginStatus!=true">*</span></label>
                                                    <p class="float-right mb-1" v-if="loginStatus!=true" style="font-size: 0.875rem;">
                                                        <span aria-hidden="true">Already have an account?</span>
                                                        <router-link :to="{ name: 'customer_login', params: { returnUrl: 'checkout' }}"
                                                            >
                                                            Log in
                                                        </router-link>
                                                    </p>
                                                    <div class="row" v-if="loginStatus==true">
                                                        <div class="col-md-2">
                                                            <a href="#" class="avatar avatar-xl rounded-circle"><img alt="Image placeholder" src="https://png.pngitem.com/pimgs/s/24-248226_computer-icons-user-profile-clip-art-login-user.png"></a>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <p class="mb-1"><small>{{CustomerDetailsLogin.first_name + ' '+ CustomerDetailsLogin.last_name}} ({{email}})</small></p>
                                                            <a v-if="gmailLoginStatus!=true" type="button" @click.prevent="logoutCustomer">Logout</a>
                                                            <GoogleLogin v-if="gmailLoginStatus==true" :params="params" :logoutButton=true :onSuccess="onSuccess">Logout</GoogleLogin>
                                                        </div>
                                                    </div>
                                                <base-input alternative="" label="Email" v-if="loginStatus!=true" type="email" v-model="email" input-classes="form-control" required />
                                            </div>
                                            <div class="col-md-12" v-if="infomationStatus == 1">
                                                <div class="row"  v-if="loginStatus!=true">
                                                    <div class="col">
                                                        <label class="form-control-label">
                                                            Shipping address
                                                            <span>*</span></label>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="loginStatus!=true">
                                                    <div class="col">
                                                        <base-input alternative="" label="First Name" v-model="firstName" placeholder="" input-classes="form-control" required />
                                                    </div>
                                                    <div class="col">
                                                        <base-input alternative="" label="Last Name" v-model="lastName" placeholder="" input-classes="form-control" required/>
                                                    </div>
                                                </div>
                                                <base-input v-if="loginStatus!=true || (loginStatus==true && CustomerDetailsLogin.mobile==null)" alternative="" label="Phone Number" type="number" v-model="phoneNumber" input-classes="form-control" required />
                                                <div class="row" v-if="loginStatus==true">
                                                    <div class="col">
                                                        <label class="form-control-label">
                                                            Shipping address
                                                            <span>*</span></label>
                                                    </div>
                                                </div>
                                                <div class="row mb-3" v-if="loginStatus==true && (CustomerDetailsLogin.region_code!=null || addressListCount>=1)">
                                                    <div class="col-md-6 border rounded " v-bind:class="{'selected-address': selectedAddress == 'Address-default' ? true : false}" @click.prevent="onChangeShippingAddress(-1)" style="cursor:pointer;" v-if="CustomerDetailsLogin.region_code!=null">
                                                        <div class="p-2">
                                                            <small>{{CustomerDetailsLogin.first_name + ' '+ CustomerDetailsLogin.last_name}}</small><br>
                                                            <small>
                                                                {{CustomerDetailsLogin.street+' '+CustomerDetailsLogin.barangay_name+' '+CustomerDetailsLogin.city_name+' '+CustomerDetailsLogin.province_name+ ' '+ CustomerDetailsLogin.region_name}}
                                                            </small><br>
                                                            <small v-if="loginStatus==true && CustomerDetailsLogin.mobile!=null">{{phoneNumber}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 border rounded" v-bind:class="{'selected-address': selectedAddress == 'Address-'+index ? true : false}" v-bind:key="'address'+index" style="cursor:pointer;" @click.prevent="onChangeShippingAddress(index)" v-for="(data,index) in addressList" v-if="addressListCount>=1 && (data.street!=CustomerDetailsLogin.street && data.barangay_name!=CustomerDetailsLogin.barangay_name && data.city_name != CustomerDetailsLogin.city_name && data.province_name!= CustomerDetailsLogin.province_name && data.region_name!=CustomerDetailsLogin.region_name)">
                                                        <div class="p-2">
                                                            <small>{{CustomerDetailsLogin.first_name + ' '+ CustomerDetailsLogin.last_name}}</small><br>
                                                            <small>
                                                                {{data.street+' '+data.barangay_name+' '+data.city_name+' '+data.province_name+ ' '+ data.region_name}}
                                                            </small><br>
                                                            <small v-if="loginStatus==true && CustomerDetailsLogin.mobile!=null">{{phoneNumber}}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-else>
                                                    <base-input class="col-md-6" label="Region" required>
                                                        <a-select v-model="address.region_code" size="large" showSearch placeholder="Select Region" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true">
                                                            <a-select-option v-for="option in addressOptions.regions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
                                                    <base-input class="col-md-6" label="Province" required>
                                                        <a-select v-model="address.province_code" size="large" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true">
                                                            <a-select-option v-for="option in addressOptions.provinces" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
            
                                                    <base-input class="col-md-6" label="City" required>
                                                        <a-select v-model="address.city_code" size="large" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true">
                                                            <a-select-option v-for="option in addressOptions.cities" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
            
                                                    <base-input class="col-md-6" label="Barangay" required>
                                                        <a-select v-model="address.barangay_code" size="large" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true">
                                                            <a-select-option v-for="option in addressOptions.barangays" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
                                                    <base-input label="House No. / Street" class="col-md-12" required>
                                                        <a-input type="text"  size="large" v-model="address.street"/>
                                                    </base-input>
                                                </div>
                                            </div>
                                            <div class="col-md-12" v-if="passwordStatus == 1">
                                                <base-input alternative="" label="New Password" type="password" v-model="newPassword" placeholder="New password" input-classes="form-control" required />
                                                <base-input alternative="" label="Confirm Password" type="password" v-model="confirmPassword" placeholder="Confirm Password" input-classes="form-control" required />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="btn-toolbar d-flex justify-content-center" >
                                                    <div class="btn-group w-100">
                                                        <base-button type="primary" class="btn float-left mr-lg-4 bg-white text-dark rounded p-2" @click.prevent="backToCart">‹ Return to cart
                                                        </base-button>
                                                        <base-button type="primary" class="btn float-right mr-0 rounded p-2" @click.prevent="shipping">Continue to Shipping
                                                        </base-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="step==2">
                                            <div class="col-md-12">
                                                <div class="custom-scrollbar-css table-responsive mb-4">
                                                    <table class="table table-bordered table-rounded mb-0 white-space-inherit">
                                                        <tbody>
                                                            <tr>
                                                                <td width="20rem">
                                                                    Contact
                                                                </td>
                                                                <td>
                                                                    {{email+' - '+phoneNumber}}
                                                                </td>
                                                                <td width="20rem">
                                                                    <a class="text-primary" role="button" @click.prevent="information">Change</a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20rem">
                                                                    Ship to
                                                                </td>
                                                                <td class="white-space-inherit">
                                                                    {{address.street+' '+address.barangay_name+' '+address.city_name+' '+address.province_name+ ' '+ address.region_name}}
                                                                </td>
                                                                <td width="20rem">
                                                                    <a class="text-primary" role="button" @click.prevent="information">Change</a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-4">
                                                <label class="form-control-label">
                                                    Shipping method
                                                    <span>*</span></label>
                                                <a-radio-group v-model="shippingMethod" class="w-100 border">
                                                    <a-radio v-if="storeDetails.is_delivery == true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="1">
                                                    delivery
                                                    </a-radio>
                                                    <a-radio v-if="storeDetails.is_store_pickup==true" class="w-100 p-2" :style="radioStyle" @click="getPhysicalStore" :value="2">
                                                        store pickup
                                                    </a-radio>
                                                        <select v-if="shippingMethod === 2" class="form-control" data-toggle="select" v-model="store" title="Simple select" data-live-search="true" data-live-search-placeholder="Select a store" @change="selectStore(store)">
                                                            <option value="">Select a store</option>
                                                            <option v-for="data in storeList" :value="data.id" v-bind:key="'Store'+data.id">
                                                                <span>{{data.name}}</span> - {{data.address}}
                                                            </option>
                                                        </select>
                                                </a-radio-group>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="btn-toolbar d-flex justify-content-center" >
                                                    <div class="btn-group w-100">
                                                        <base-button type="default" class="btn float-left mr-lg-4 bg-white text-dark rounded p-2" @click.prevent="information">‹ Return to Information
                                                        </base-button>
                                                        <base-button type="primary" class="btn float-right mr-0 rounded p-2" @click.prevent="payment">Continue to Payment
                                                        </base-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="step==3">
                                            <div class="col-md-12">
                                                <div class="custom-scrollbar-css table-responsive mb-4">
                                                    <table class="table table-bordered table-rounded mb-0 white-space-inherit">
                                                        <tbody>
                                                            <tr>
                                                                <td width="20rem">
                                                                    Contact
                                                                </td>
                                                                <td>
                                                                    {{email+' - '+phoneNumber}}
                                                                </td>
                                                                <td width="20rem">
                                                                    <a class="text-primary" role="button" @click.prevent="information">Change</a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20rem">
                                                                    Ship to
                                                                </td>
                                                                <td class="white-space-inherit">
                                                                    {{address.street+' '+address.barangay_name+' '+address.city_name+' '+address.province_name+ ' '+ address.region_name}}
                                                                </td>
                                                                <td width="20rem">
                                                                    <a class="text-primary" role="button" @click.prevent="information">Change</a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td width="20rem">
                                                                    Method
                                                                </td>
                                                                <td>
                                                                    {{shippingMethod == 1 ? 'Cash on delivery' : shippingMethod == 2 ? 'store pickup' : ''}}
                                                                </td>
                                                                <td width="20rem">
                                                                    <a class="text-primary" role="button" @click.prevent="shipping">Change</a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-4">
                                                <label class="form-control-label">
                                                    Payment
                                                    <span>*</span></label>
                                                <a-radio-group v-model="paymentMethod" class="w-100 border">
                                                    <a-radio v-if="shippingMethod==1 && storeDetails.is_cod==true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="1">
                                                    Cash on delivery
                                                    </a-radio>
                                                    <a-radio v-else-if="shippingMethod==2 && storeDetails.is_cop==true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="2">
                                                        Cash on pickup
                                                    </a-radio>
                                                    <a-radio v-if="storeDetails.is_paymaya == true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="3">
                                                        Paymaya
                                                    </a-radio>
                                                    <a-radio v-if="storeDetails.is_dragonpay == true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="4">
                                                        Dragonpay
                                                    </a-radio>
                                                    <a-radio v-if="storeDetails.is_ipay88 == true" class="w-100 p-2 border-bottom" :style="radioStyle" :value="5">
                                                        Ipay88
                                                    </a-radio>
                                                        <a-select showSearch  v-if="paymentMethod == 4"  style="width: 100%" size="large" placeholder="Please select payment method" optionFilterProp="children"  v-model="paymentDragonpayMethod">
                                                            <a-select-option v-for="option in paymentMethods" :key="option.procId" :value="option.procId">{{option.shortName}}</a-select-option>
                                                        </a-select>
                                                        <a-select showSearch  v-if="paymentMethod == 5"  style="width: 100%" size="large" placeholder="Please select payment method" optionFilterProp="children"  v-model="ipay88PaymentRequest.PaymentId">
                                                            <a-select-option v-for="option in ipay88PaymentMethods" :key="option.payment_id" :value="option.payment_id">{{option.payment_name}}</a-select-option>
                                                        </a-select>
                                                </a-radio-group>
                                            </div>
                                            <div class="col-md-12">
                                                <a-button type="primary" size="large" :loading="completeOrderLoading" class="btn float-right mr-0 btn-primary" @click.prevent="completeOrder">Complete order
                                                </a-button>
                                                <base-button type="default" class="btn float-left mr-0 bg-white text-dark" @click.prevent="shipping">‹ Return to shipping
                                                </base-button>
                                            </div>
                                            <form class="d-none" method="post" name="ePayment" :action="ipay88PaymentRequest.postURL">
                                                <input type="hidden" name="MerchantCode" :value="ipay88PaymentRequest.MerchantCode">
                                                <input type="hidden" name="PaymentId" :value="ipay88PaymentRequest.PaymentId">
                                                <input type="hidden" name="RefNo" :value="ipay88PaymentRequest.RefNo">
                                                <input type="hidden" name="Amount" :value="ipay88PaymentRequest.Amount">
                                                <input type="hidden" name="Currency" :value="ipay88PaymentRequest.Currency">
                                                <input type="hidden" name="ProdDesc" :value="ipay88PaymentRequest.ProdDesc">
                                                <input type="hidden" name="UserName" :value="ipay88PaymentRequest.UserName">
                                                <input type="hidden" name="UserEmail" :value="ipay88PaymentRequest.UserEmail">
                                                <input type="hidden" name="UserContact" :value="ipay88PaymentRequest.UserContact">
                                                <input type="hidden" name="Remark" :value="ipay88PaymentRequest.Remark">
                                                <input type="hidden" name="Lang" :value="ipay88PaymentRequest.Lang">
                                                <input type="hidden" name="SignatureType" :value="ipay88PaymentRequest.SignatureType">
                                                <input type="hidden" name="Signature" :value="ipay88PaymentRequest.Signature">
                                                <input type="hidden" name="ResponseURL" :value="ipay88PaymentRequest.ResponseURL">
                                                <input type="hidden" name="BackendURL" :value="ipay88PaymentRequest.BackendURL">
                                                <input ref="submitIpay88" type="submit" name="Submit" hidden value="Proceed with payment">
                                            </form>
                                        </div>
                                        <div class="row" v-if="step==4">
                                            <div class="col-md-12">
                                                <span>Order #{{orderResponse.id}}</span>
                                                <div class="w-100 p-3 mt-5 border">
                                                    <h2>Your order is confirmed</h2>
                                                </div>
                                                <div class="card w-100 p-3 mt-2">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <label class="form-control-label">
                                                                Contact information
                                                            </label>
                                                            <p>{{email}}</p>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-control-label">
                                                                Payment Method
                                                            </label>
                                                            <p>{{paymentMethod == 1 ? 'Cash on delivery' : paymentMethod == 2 ? 'Cash on pickup' : paymentMethod == 3 ? 'Paymaya' : paymentMethod == 4 ? "Dragonpay" : paymentMethod == 5 ? "Ipay88" : ''}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <label class="form-control-label">
                                                                Shipping address
                                                            </label>
                                                            <p> {{address.street+' '+address.barangay_name+' '+address.city_name+' '+address.province_name+ ' '+ address.region_name}}</p>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-control-label">
                                                                Shipping Method
                                                            </label>
                                                            <p>{{shippingMethod == 1 ? 'delivery' : shippingMethod == 2 ? 'store pickup' : ''}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-3">
                                                <base-button type="primary" class="btn float-right mr-0" @click.prevent="continueShoping">Finish
                                                </base-button>
                                            </div>
                                        </div>
                                        <div class="row" v-if="step==5">
                                            <div class="col-md-12">
                                                <div class="btn-toolbar d-flex justify-content-center" >
                                                    <div class="btn-group w-100">
                                                        <base-button type="primary" class="btn float-left mr-lg-4 bg-white text-dark rounded p-2" @click.prevent="backToCart">‹ Cancel order
                                                        </base-button>
                                                        <a-button type="primary" size="large" :loading="completeOrderLoading" class="btn float-right mr-0 btn-primary rounded" @click.prevent="completeOrder">Retry complete order
                                                        </a-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a-spin>
                                </div>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 border-left section-lg pt-lg-5 pr-lg-0" style="background:rgb(250, 250, 250)">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="container">
                                    <div class="table-responsive">
                                        <table class="table table-borderless">
                                            <tbody>
                                                <tr v-for="(order, orderIndex) in OrderListData" v-bind:key="orderIndex">
                                                    <td>
                                                        <div class="product-thumbnail">
                                                            <template>
                                                                <v-lazy-image v-if="order.filename!=null && order.filename!=''" class="img img-responsive product-thumbnail__image" :src="imageUrl+'/'+order.filename"/>
                                                                <v-lazy-image v-else class="img  img-responsive product-thumbnail__image" src="http://localhost:3026/product_images/product-default.png" />
                                                            </template>
                                                            <sup><badge class="badge-pill font-weight-bold float-right text-white" style="margin-right: -.7rem;font-size: 1em;" tag="a" type="default">{{order.quantity}}</badge></sup>
                                                        </div>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span>{{order.name}}</span><br>
                                                        <small>
                                                            <span>
                                                                {{order.color_name}}
                                                                <span v-if="order.color_name !=null && order.size_name!=null"> / </span>
                                                                {{order.size_name}}
                                                                <span v-if="order.size_name !=null && order.design_name!=null"> / </span>
                                                                {{order.design_name}}
                                                            </span>
                                                        </small>
                                                    </td>
                                                    <td class="align-middle" align="right">{{formatPrice(order.retail_price*order.quantity)}}</td>
                                                </tr>
                                                <tr class="border-top">
                                                    <td colspan="2" align="left"><h5>Subtotal</h5></td>
                                                    <td align="right" class="font-weight-bold">{{formatPrice(subtotal=totalItem())}}</td>
                                                </tr>
                                                <tr v-if="shippingMethod!=null">
                                                    <td colspan="2" align="left"><h5>Shipping fee</h5></td>
                                                    <td align="right" class="font-weight-bold" v-if="totalShippingFee()!=0">{{formatPrice(shippingFee=totalShippingFee())}}</td>
                                                    <td align="right" class="font-weight-bold" v-else>Free</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" align="left"><h5>Total</h5></td>
                                                    <td align="right" class="font-weight-bold">{{formatPrice(totalAmount)}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                    </div>
                </div>
        </section>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import {hex_sha1, iPay88Signature, str_sha1, hex_hmac_sha1, b64_hmac_sha1, str_hmac_sha1} from '../../components/ipayHash.js'
import {SHA256} from '../../components/ipayHash256.js'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from "axios"
import CookieConsent from 'vue-cookieconsent-component'
import GoogleLogin from 'vue-google-login'
var options = {}
var component_x;
export default {
    components: {
        HTTPRequest,
        CookieConsent
    },
    computed: {
        ...mapState(['endPoint', 'parameters','publicUrl'])
    },
    data() {
        return {
            OrderListData:[],
            radioStyle: {
                display: 'block',
                lineHeight: '30px',
            },
            totalAmount:0,
            infoStatus:false,
            ShipStatus:null,
            paymentStatus:null,
            step:1,
            email:null,
            phoneNumber:null,
            firstName:null,
            lastName:null,
            address: {
                region_code: null,
                region_name: "",
                province_code: null,
                province_name: "",
                city_code: null,
                city_name: "",
                barangay_code: null,
                barangay_name: "",
                street:null
            },
            addressOptions: {
                regions: [],
                provinces: [],
                cities: [],
                barangays: []
            },
            response: [],
            addressLoading: false,
            shippingMethod:null,
            store:null,
            paymentMethod:null,
            storeList:[],
            errors:[],
            orderResponse:{},
            documentDate: moment(new Date()),
            targetDate:  moment(new Date()),
            cancellationDate: null,
            completeOrderLoading:false,
            infomationStatus:1,
            passwordStatus:2,
            infomationFunctionStatus:null,
            newPassword:null,
            confirmPassword:null,
            cookiesConsentStatus:null,
            cookiesConsentStatusGivenAt:null,
            loginStatus:null,
            CustomerDetailsLogin:null,
            gmailLoginStatus:null,
            amountGross:0.00,
            amountNet:0.00,
            totalQuantity:0,
            addressList:[],
            addressListCount:0,
            selectedAddress:null,
            storeDetails:{},
            salesChannelId:null,
            paymentMethods: [],
            ipay88PaymentMethods:[],
            paymentDragonpayMethod:null,
            imageUrl:null,
            paymentStatusLoading:false,
            paymayaPaymentStatus:null,
            dragonpayPaymentdetails:{},
            ipay88Paymentdetails:{},
            subtotal:0.00,
            shippingFee:0.00,
            selectedAddressId:null,
            ipay88PaymentRequest:{
                postURL:null,
                MerchantCode:null,
                MerchantKey:null,
                PaymentId:null,
                RefNo:null,
                Amount:null,
                Currency:null,
                ProdDesc:null,
                UserName:null,
                UserEmail:null,
                UserContact:null,
                Remark:'',
                Lang:"UTF-8",
                SignatureType:"SHA256",
                Signature:null,
                ResponseURL:null,
                BackendURL:null,
            },
            documentShippingMethodId:null,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            component_x = this
            this.imageUrl = this.publicUrl + 'product_images'
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.cookiesConsentStatus = CookieConsent.methods.getCookie(this.storeDetails.account_id+'_'+this.storeDetails.name+'_cookieconsent_status')
            this.cookiesConsentStatusGivenAt = CookieConsent.methods.getCookie(this.storeDetails.account_id+'_'+this.storeDetails.name+'_cookieconsent_datetime')
            this.loginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.CustomerDetailsLogin = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
            if (this.loginStatus== true){
                this.email = this.CustomerDetailsLogin.email
                this.firstName = this.CustomerDetailsLogin.first_name
                this.lastName = this.CustomerDetailsLogin.last_name
                this.phoneNumber = this.CustomerDetailsLogin.mobile !=null ? this.CustomerDetailsLogin.mobile : null
                this.getUserAddress()
                if (this.CustomerDetailsLogin.region_code == null){
                    this.infomationFunctionStatus = "update"
                } else{
                    this.selectedAddress = "Address-default"
                    this.address.region_code = this.CustomerDetailsLogin.region_code
                    this.address.region_name = this.CustomerDetailsLogin.region_name
                    this.address.province_code = this.CustomerDetailsLogin.province_code
                    this.address.province_name = this.CustomerDetailsLogin.province_name
                    this.address.city_code = this.CustomerDetailsLogin.city_code
                    this.address.city_name = this.CustomerDetailsLogin.city_name
                    this.address.barangay_code = this.CustomerDetailsLogin.barangay_code
                    this.address.barangay_name = this.CustomerDetailsLogin.barangay_name
                    this.address.street= this.CustomerDetailsLogin.street
                }
            }
            this.OrderList()
            this.$emit('hideFooterAndHeader', event)
            await this.changeAddress('regions', 1);
            if (this.OrderListData.length<=0){
                this.$router.replace({ name: 'store',params:{ storeId:this.$route.params.storeId }})
            }else {
                var c = this.getQueryParams(window.location.hash)
                c = Object.keys(c).length != 0 ? c : this.$route.query  
                if (c["paymant_status"] !=undefined){
                    this.paymayaPaymentStatus = c["paymant_status"]
                    this.shippingMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-shippingMethod")
                    this.paymentMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentMethod")
                    this.address = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-address")
                    this.email = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-email")
                    switch (c["paymant_status"]) {
                        case "success":
                            this.paymentStatusLoading = true
                            this.postDocument(secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-tempDocument"),secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-orderResponse"))
                        break;
                        default:
                            this.errors = [];
                            this.errors.push("payment failed");
                            this.$router.replace({name: 'checkout', params:{ storeId:this.$route.params.storeId }})
                            this.step=3
                        break;
                    }
                } else if (c["status"]!=undefined && c["txnid"]!=undefined){
                    c["message"] = decodeURIComponent(c["message"])
                    this.dragonpayPaymentdetails = c 
                    this.shippingMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-shippingMethod")
                    this.paymentMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentMethod")
                    this.paymentDragonpayMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentDragonpayMethod")
                    this.address = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-address")
                    this.email = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-email")
                    switch (c["status"]) {
                        case "S":
                            this.paymentStatusLoading = true
                            this.postDocument(secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-tempDocument"),secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-orderResponse"))
                        break;
                        default:
                            this.errors = [];
                            this.errors.push("payment failed");
                            this.$router.replace({name: 'checkout', params:{ storeId:this.$route.params.storeId }})
                            this.step=3
                        break;
                    }
                }else if(c["Status"]!=undefined && c["TransId"]!=undefined){
                    this.ipay88Paymentdetails = c
                    this.shippingMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-shippingMethod")
                    this.paymentMethod = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentMethod")
                    this.ipay88PaymentRequest.PaymentId = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-PaymentId")
                    this.address = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-address")
                    this.email = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-email")
                    switch (c["Status"]) {
                        case "1":
                            this.paymentStatusLoading = true
                            this.postDocument(secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-tempDocument"),secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-orderResponse"))
                        break;
                        default:
                            this.errors = [];
                            console.log(this.ipay88Paymentdetails)
                            this.errors.push("payment failed");
                            this.errors.push(this.ipay88Paymentdetails.ErrDesc);
                            this.$router.replace({name: 'checkout', params:{ storeId:this.$route.params.storeId }})
                            this.step=3
                        break;
                    }
                }else{}
                console.log(window.location)
            }
            this.totalAmount=this.totalItem()+this.totalShippingFee()
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'checkout', storeId:this.$route.params.storeId }})
        }
    },
    watch:{
        'email': function (id) {
            this.passwordStatus = 2
        },
        paymentMethod: async function() {
            if(this.paymentMethod == 4 && this.paymentMethods.length == 0){
                var response = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_dragonpay_processors', null)
                component_x.paymentMethods = response
            }else if (this.paymentMethod == 5 && this.ipay88PaymentMethods.length == 0){
                var response = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_ipay88_payment_methods', null)
                var arr = []
                for (var i = 0; i < this.storeDetails.ipay88_payment_methods.length; i++) {
                    var check_index = response.findIndex(x=> x.payment_id == this.storeDetails.ipay88_payment_methods[i])
                    if (check_index>=0){
                        arr.push(response[check_index])
                    }
                }
                component_x.ipay88PaymentMethods = arr
            }else{
                component_x.ipay88PaymentMethods = []
                component_x.paymentMethods = []
            }
        },
        shippingMethod: function(){
            this.totalAmount=this.subtotal+this.totalShippingFee()
        }
    },
    methods:{
        OrderList: async function(){
            var gData = secureStorage.getItem("CheckoutOrderListData"+this.storeDetails.name);
            if (gData !='' && gData !=null){
                this.OrderListData = gData;
                console.log(this.OrderListData)
                this.totalAmount = 0;
            }
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        totalItem: function(){
            let sum = 0;
            for(let i = 0; i < this.OrderListData.length; i++){
                sum += (parseFloat(this.OrderListData[i].retail_price) * parseFloat(this.OrderListData[i].quantity));
            }
            return sum;
        },
        handleChange(value) {
            this.country = value
        },
        handleBlur() {
        },
        handleFocus() {
        },
        selectStore(value){
            console.log(value)
            this.store = value
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getPhysicalStore: async function(){
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/get_physical_stores?sales_channel_id='+this.storeDetails.id, null)  
            this.storeList = response
        },
        information: function(){
            this.step = 1;
            this.infoStatus = false;
            this.ShipStatus = true;
        },
        InformationValidation(){
            this.errors = [];
            this.errors.push(ValidateField.emailFormat('Email', this.email));
            this.errors.push(ValidateField.charMinAndMax('Email', this.email, 0, 40));
            this.errors.push(ValidateField.required('Phone number', this.phoneNumber));
            this.errors.push(ValidateField.phoneNumberFormat('Phone number', this.phoneNumber));
            this.errors.push(ValidateField.charMinAndMax('Phone number', this.phoneNumber, 0, 30));
            this.errors.push(ValidateField.required('First Name', this.firstName));
            this.errors.push(ValidateField.alphanumericWithSpace('First Name', this.firstName));
            this.errors.push(ValidateField.charMinAndMax('First Name', this.firstName, 0, 70));
            this.errors.push(ValidateField.required('Last Name', this.lastName));
            this.errors.push(ValidateField.alphanumericWithSpace('Last Name', this.lastName));
            this.errors.push(ValidateField.charMinAndMax('Last Name', this.lastName, 0, 30));
            if(this.loginStatus==true && (this.CustomerDetailsLogin.region_code!=null || this.addressListCount>=1)){
                if (this.selectedAddress==null){
                    this.errors.push(ValidateField.required('Shipping Address', this.selectedAddress));
                }
            }else{
                this.errors.push(ValidateField.required('Region', this.address.region_code));
                this.errors.push(ValidateField.charMinAndMax('Region', this.address.region_name, 0, 200));
                this.errors.push(ValidateField.required('Province', this.address.province_code));
                this.errors.push(ValidateField.charMinAndMax('Province', this.address.province_name, 0, 100));
                this.errors.push(ValidateField.required('City', this.address.city_code));
                this.errors.push(ValidateField.charMinAndMax('City', this.address.city_name, 0, 60));
                this.errors.push(ValidateField.required('Barangay', this.address.barangay_code));
                this.errors.push(ValidateField.charMinAndMax('Barangay', this.address.barangay_name, 0, 60));
                this.errors.push(ValidateField.required('House No. / Street', this.address.street));
                this.errors.push(ValidateField.charMinAndMax('House No. / Street', this.address.street, 0, 100));
            }
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        InformationPasswordValidation(){
            this.errors = [];
            this.errors.push(ValidateField.required('New Password', this.newPassword));
            this.errors.push(ValidateField.matchData('Password',this.newPassword,this.confirmPassword))
            this.errors.push(ValidateField.required('Confirm Password', this.confirmPassword));
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        backToCart: function(){
            this.$emit('showFooterAndHeader', event)
            this.$router.push({ name: 'cart', params:{storeId:this.$route.params.storeId}})
        },
        shipping: async function(){
            if(!this.InformationValidation()) {
                switch (true) {
                    case (this.passwordStatus == 2):
                        var customer = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/get_customer_info?account_id='+this.storeDetails.account_id + '&email='+this.email, null)
                        if (customer!=null){
                            if (customer["error"] == undefined){
                                    // step = 2
                                    this.step == 3 ? this.paymentStatus = true : ''
                                    this.step = 2;
                                    this.infoStatus = true;
                                    this.ShipStatus = false;
                            }else {
                                this.errorMessage = customer["error"]
                            }
                        }else{
                            this.passwordStatus = 1
                            this.infomationFunctionStatus = "create"
                        }
                    break;
                    case (this.passwordStatus == 1):
                        if(!this.InformationPasswordValidation()){
                            this.step == 3 ? this.paymentStatus = true : ''
                            this.step = 2;
                            this.infoStatus = true;
                            this.ShipStatus = false;
                        }
                    break;
                    default:
                    break;
                }
            }
        },
        shippingValidation(){
            this.errors = [];
            this.errors.push(ValidateField.required('Shipping Method', this.shippingMethod));
            if (this.shippingMethod === 2){
                this.errors.push(ValidateField.required('Store', this.store));
            }
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        payment: function(){
            if(!this.shippingValidation()) {
                this.step = 3;
                this.ShipStatus = true;
                this.paymentStatus = false;
                this.getPhysicalStore()
            }
        },
        paymentValidation(){
            this.errors = [];
            this.errors.push(ValidateField.required('Payment', this.paymentMethod));
            if (this.paymentMethod == 4){
                this.errors.push(ValidateField.required('Payment Method', this.paymentDragonpayMethod));
            }else if (this.paymentMethod == 5){
                this.errors.push(ValidateField.required('Payment Method', this.ipay88PaymentRequest.PaymentId));
            }
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        completeOrder: async function(){
            if(!this.paymentValidation()) {
                this.completeOrderLoading = true
                await HTTPRequest.authenticate(this.endPoint)
                var documentLines = []
                this.OrderListData.forEach((order,index)=>{
                    var orderTemplate = {
                        parent_line_no:0,
                        product_type:order.product_type,
                        product_id:order.product_id,
                        barcode:order.barcode,
                        actual_quantity:0,
                        on_hand_quantity:0,
                        unit_id:order.unit_id,
                        content_quantity:order.content_quantity,
                        product_name:order.name,
                        tax_type:order.tax_type,
                        quantity:order.quantity,
                        price:order.retail_price,
                        subtotal:order.retail_price*order.quantity,
                        subtotal_without_vat:order.retail_price*order.quantity,
                        price_without_vat:order.retail_price*order.quantity,
                        cost:order.landed_cost,
                        remarks:null,
                        tax_rate:0,
                        tax_amount:0,
                        reward_code:null,
                        reward_discount_amount:0,
                        line_no:index+1,
                    }
                    this.amountGross += order.retail_price*order.quantity
                    this.amountNet += order.retail_price*order.quantity
                    this.totalQuantity += order.quantity
                    documentLines.push(orderTemplate);
                })
                var shipping_method_name = this.shippingMethod == 1 ? 'Delivery' : this.shippingMethod == 2 ? 'Pickup' : '';
                var shipping_type = this.shippingMethod == 1 ? 'D' : this.shippingMethod == 2 ? 'P' : '';
                if (documentLines.length > 0){
                    await this.getShippingMethod(shipping_method_name,shipping_type)
                    var get_document_type = await HTTPRequest.getRequest(this.endPoint + '/document_types?type_code=SOX&trans_code=ORI',null)
                    if (get_document_type){
                        var documentPayload = {
                            document: {
                                is_header_only:false,
                                site_id: this.paymentMethod == 2 ? this.store : this.shippingMethod == 1 && this.storeDetails.site_id != null ? this.storeDetails.site_id : this.storeList[0].id,
                                total_quantity: this.totalQuantity,
                                document_type_id: get_document_type[0].id,
                                document_type_code: get_document_type[0].type_code,
                                document_trans_code: get_document_type[0].trans_code,
                                document_date: this.documentDate,
                                party_id: -1,
                                target_date: this.targetDate,
                                cancellation_date: this.cancellationDate,
                                discount_text: null,
                                remark: null,
                                order_status: 'U',
                                amount_gross:this.amountGross,
                                gross_amount_without_tax:this.amountGross,
                                amount_header_discount: 0,
                                amount_net:this.amountNet,
                                net_amount_without_tax:this.amountNet,
                                tax_amount:0,
                                tax_exempt_amount: 0,
                                tax_rate: 0,
                                amount_line_discount: 0,
                                party_receiver_name: "",
                                payment_term_id: 1,
                                order_source: "online store",
                                origin_document_id:-1,
                                shipping_method_id:this.documentShippingMethodId,
                                document_no: 1, //TEST ONLY,
                                document_lines: documentLines
                            }
                        }
                        if (this.storeDetails.sublocation_id != null && this.shippingMethod != 2){
                            documentPayload.document.target_sublocation_id = this.storeDetails.sublocation_id
                        }
                        if (this.selectedAddressId!=null){
                            documentPayload.document.address_id = this.selectedAddressId
                        }
                        if (this.shippingFee !=0 && this.shippingFee!=null && this.shippingFee!=undefined && this.shippingMethod == 1){
                            documentPayload.document.document_charges = [{
                                line_no:-1,
                                name:"Shipping fee",
                                amount:this.shippingFee,
                            }]
                        }
                        var orderPayload = {
                            order: {
                                email: this.email, 
                                contact_number: this.phoneNumber, 
                                name:this.firstName+' '+this.lastName.charAt(0).toUpperCase()+'.',
                                first_name: this.firstName, 
                                last_name: this.lastName, 
                                address: this.address.street+' '+this.address.barangay_name+' '+this.address.city_name+' '+this.address.province_name+' '+ this.address.region_name,
                                granular_address: this.address,
                                orders: this.OrderListData,
                                total_amount: this.totalAmount,
                                remarks: this.shippingMethod == 1 ? 'delivery' : this.shippingMethod == 2 ? 'store pickup' : null,
                                shopping_method: this.shippingMethod == 1 ? 'delivery' : this.shippingMethod == 2 ? 'store pickup' : null,
                                site_pickup_id: this.shippingMethod == 2 ? this.store : null,
                                payment: this.paymentMethod == 1 ? 'Cash on delivery' : this.paymentMethod == 2 ? 'Cash on Pickup' : this.paymentMethod == 3 ? "paymaya" : this.paymentMethod == 4 ? "dragonpay" : null,
                                customer_status:this.infomationFunctionStatus,
                                password:this.newPassword,
                                document_id:null,
                            }
                        }
                        this.cookiesConsentStatus != null ? orderPayload.order.consent = {cookies_consent:this.cookiesConsentStatus,cookies_consent_given_at:this.cookiesConsentStatusGivenAt,} : ''
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'orders?name='+this.storeDetails.name+'&account_id='+this.storeDetails.account_id, null, orderPayload)    
                        if (post_request["error"] == undefined) {
                            this.orderResponse = post_request
                            documentPayload.document.reference_1 = this.orderResponse.id
                            if (this.paymentMethod == 3 || this.paymentMethod == 4 || this.paymentMethod == 5){
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-tempDocument",documentPayload)
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-orderResponse",this.orderResponse)
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-shippingMethod",this.shippingMethod)
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentMethod",this.paymentMethod)
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-address",this.address)
                                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-email",this.email)
                                this.paymentMethod == 4 ? secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentDragonpayMethod",this.paymentDragonpayMethod) : ''
                                this.paymentMethod == 5 ? secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-PaymentId",this.ipay88PaymentRequest.PaymentId) : ''
                                this.onlinePayment()
                            }else{
                                this.postDocument(documentPayload,post_request)
                            }
                        } else {
                            this.completeOrderLoading = false
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            }
        },
        continueShoping: function(){
            this.$emit('showFooterAndHeader', event)
            this.$router.push({ name: 'catalog', params:{storeId:this.$route.params.storeId}})
        },
        logoutCustomer(){
            secureStorage.removeItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
            secureStorage.removeItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.checkLoginStatus()
        },
        checkLoginStatus(){
            this.loginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.gmailLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-gmailStatus")
        },
        onSuccess(){
            this.logoutCustomer()
        },
        changeAddress: async function(list, fresh = 0){
            this.addressLoading = true
            switch(list) {
            case 'regions':
                await this.getAddressList(null, null, list)
                this.sort(this.response)
                this.addressOptions = {
                    regions: this.response,
                    provinces: [],
                    cities: [],
                    barangays: []
                }
                if(fresh == 0){
                    Object.assign(this.address, {
                        province_code: null,
                        province_name: "",
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });    
                }
                break;
            case 'provinces':
                let province_list = []
                let district_list = []
                if(this.address.region_code != null){
                    await this.getAddressList(list, this.address.region_code, 'regions')
                    province_list = this.response
                    
                    await this.getAddressList('districts', this.address.region_code, 'regions')
                    district_list = this.response

                    Object.assign(this.address, {
                        region_name: this.addressOptions.regions.find(x => x.code === this.address.region_code).name
                    })
                }
                let provinces_arr = province_list.concat(district_list)
                this.sort(provinces_arr)
                Object.assign(this.addressOptions, {
                    provinces: provinces_arr,
                    cities: [],
                    barangays: []
                });
                if(fresh == 0){
                    Object.assign(this.address, {
                        province_code: null,
                        province_name: "",
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });
                }
                break;
            case 'cities':
                let province_city_list = []
                let province_municipality_list = []
                let province_sub_municipality_list = []
                let district_city_list = []
                let district_municipality_list = []
                let district_sub_municipality_list = []

                if(this.address.province_code != null){
                    await this.getAddressList(list, this.address.province_code, 'provinces')
                    province_city_list = this.response

                    await this.getAddressList('municipalities', this.address.province_code, 'provinces')
                    province_municipality_list = this.response

                    await this.getAddressList('sub-municipalities', this.address.province_code, 'provinces')
                    province_sub_municipality_list = this.response

                    await this.getAddressList(list, this.address.province_code, 'districts')
                    district_city_list = this.response

                    await this.getAddressList('municipalities', this.address.province_code, 'districts')
                    district_municipality_list = this.response

                    await this.getAddressList('sub-municipalities', this.address.province_code, 'districts')
                    district_sub_municipality_list = this.response

                    Object.assign(this.address, {
                        province_name: this.addressOptions.provinces.find(x => x.code === this.address.province_code).name
                    })
                }
                let cities_arr = province_city_list.concat(province_municipality_list, province_sub_municipality_list, district_city_list, district_municipality_list, district_sub_municipality_list)
                this.sort(cities_arr)
                Object.assign(this.addressOptions, {
                    cities: cities_arr,
                    barangays: []
                });
                if(fresh == 0){
                    Object.assign(this.address, {
                        city_code: null,
                        city_name: "",
                        barangay_code: null,
                        barangay_name: ""
                    });
                }
                break;
            case 'barangays':
                let city_barangay_list = []
                let municipality_barangay_list = []
                let sub_municipality_barangay_list = []
                if(this.address.city_code != null){
                    await this.getAddressList(list, this.address.city_code, 'cities')
                    city_barangay_list = this.response
                    await this.getAddressList(list, this.address.city_code, 'municipalities')
                    municipality_barangay_list = this.response
                    await this.getAddressList(list, this.address.city_code, 'sub-municipalities')
                    sub_municipality_barangay_list = this.response

                    Object.assign(this.address, {
                        city_name: this.addressOptions.cities.find(x => x.code === this.address.city_code).name
                    })
                    this.addressOptions.barangays = this.response
                }
                let barangay_arr = city_barangay_list.concat(municipality_barangay_list, sub_municipality_barangay_list)
                this.sort(barangay_arr)
                Object.assign(this.addressOptions, {
                    barangays: barangay_arr
                });
                if(fresh == 0){
                    Object.assign(this.address, {
                        barangay_code: null,
                        barangay_name: ""
                    });
                }
                break;
            default:
                if(this.address.barangay_code != null){
                    Object.assign(this.address, {
                        barangay_name: this.addressOptions.barangays.find(x => x.code === this.address.barangay_code).name
                    })
                }
            }
            this.addressLoading = false
        },
        getAddressList: async function(list, parent_code, parentList){
            let code
            if (parent_code == null){
                code = ''
            } else {
                code = parent_code + '/' + list
            }
            await axios({
                method: 'GET',
                url: 'https://psgc.gitlab.io/api/' + parentList + '/' + code
            })
            .then(function (response) {
                let response_data = response.data
                let response_array = []
                for (let index = 0; index < response_data.length; index++) {
                    let row_set = response_data[index]
                    response_array.push({
                        code: row_set.code.toString(),
                        name: row_set.name
                    })
                }
                component_x.response = response_array
            }).catch(err => {
                component_x.response = []
            })
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        onChangeShippingAddress(index){
            if (index==-1){
                this.selectedAddress = "Address-default"
                this.address.region_code = this.CustomerDetailsLogin.region_code
                this.address.region_name = this.CustomerDetailsLogin.region_name
                this.address.province_code = this.CustomerDetailsLogin.province_code
                this.address.province_name = this.CustomerDetailsLogin.province_name
                this.address.city_code = this.CustomerDetailsLogin.city_code
                this.address.city_name = this.CustomerDetailsLogin.city_name
                this.address.barangay_code = this.CustomerDetailsLogin.barangay_code
                this.address.barangay_name = this.CustomerDetailsLogin.barangay_name
                this.address.street= this.CustomerDetailsLogin.street
                this.selectedAddressId = null
            }else{
                this.selectedAddress = "Address-"+index
                this.address.region_code = this.addressList[index].region_code
                this.address.region_name = this.addressList[index].region_name
                this.address.province_code = this.addressList[index].province_code
                this.address.province_name = this.addressList[index].province_name
                this.address.city_code = this.addressList[index].city_code
                this.address.city_name = this.addressList[index].city_name
                this.address.barangay_code = this.addressList[index].barangay_code
                this.address.barangay_name = this.addressList[index].barangay_name
                this.address.street= this.addressList[index].street
                this.selectedAddressId = this.addressList[index].id
            }
            console.log(this.selectedAddressId)
        },
        onlinePayment: async function(){
            var document = {
                amount_net:this.orderResponse.total_amount,
                amount_header_discount:0,
                tax_amount:0,
                gross_amount_without_tax:this.orderResponse.total_amount,
                order_source:"online store",
                id:this.orderResponse.id,
                customer_id: {
                    key:this.orderResponse.customer_id
                },
                redirect_url: window.location.href,
            }
            if(this.paymentMethod == 3){
                var request_body = {
                    type: "paymaya",
                    document: document,
                    ecom: true
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)
                if(post_request["error"] == undefined){
                    if(post_request["payment_url"]!=null && post_request["payment_url"]!=''){
                        window.location.href = post_request["payment_url"];
                    }
                }
            } else if(this.paymentMethod == 4) {
                var request_body = {
                    type: "dragonpay",
                    document: document,
                    procId: this.paymentDragonpayMethod,
                    ecom: true
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)
                if(post_request["error"] == undefined){
                    if(post_request["payment_url"]!=null && post_request["payment_url"]!=''){
                        window.location.href = post_request["payment_url"];
                    }
                }
            } else if(this.paymentMethod == 5){
                console.log(document)
                var get_customer = await HTTPRequest.getRequest(this.endPoint + 'customers/'+document.customer_id.key, null)
                if(get_customer["error"] == undefined){
                    var get_merchant_details = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_ipay88_merchant_details', null)
                    console.log(get_merchant_details)
                    if(get_merchant_details["error"] == undefined){
                        this.ipay88PaymentRequest.postURL = get_merchant_details["post_url"]
                        this.ipay88PaymentRequest.MerchantCode = get_merchant_details["merchant_code"]
                        this.ipay88PaymentRequest.MerchantKey = get_merchant_details["merchant_key"]
                        this.ipay88PaymentRequest.RefNo = document.id
                        this.ipay88PaymentRequest.Amount = document.amount_net
                        // this.ipay88PaymentRequest.Amount = '15.00'
                        this.ipay88PaymentRequest.Currency = "PHP"
                        this.ipay88PaymentRequest.ProdDesc = "BXI Order from " + document.order_source
                        this.ipay88PaymentRequest.UserName = get_customer["name"]
                        this.ipay88PaymentRequest.UserEmail = get_customer["email"]
                        this.ipay88PaymentRequest.UserContact = get_customer["mobile"]
                        this.ipay88PaymentRequest.Remark = ''
                        this.ipay88PaymentRequest.Lang = "UTF-8"
                        this.ipay88PaymentRequest.SignatureType = "SHA256"
                        var signature = this.ipay88PaymentRequest.MerchantKey+""+this.ipay88PaymentRequest.MerchantCode+""+this.ipay88PaymentRequest.RefNo+""+document.amount_net.replace(".", "")+""+this.ipay88PaymentRequest.Currency
                        // var signature = this.ipay88PaymentRequest.MerchantKey+""+this.ipay88PaymentRequest.MerchantCode+""+this.ipay88PaymentRequest.RefNo+"1500PHP"
                        this.ipay88PaymentRequest.Signature = SHA256(signature)
                        // this.ipay88PaymentRequest.ResponseURL = this.endPoint + "sales_channel_products/ipay88_response?redirect_url="+window.location.href
                        this.ipay88PaymentRequest.ResponseURL = "https://infio.iretailcloud.net/bxi_ipay88_response?redirect_url="+window.location.href
                        // this.ipay88PaymentRequest.ResponseURL = this.endPoint + "sales_channel_products/bxi_ipay88_backend
                        this.ipay88PaymentRequest.BackendURL = "https://infio.iretailcloud.net/bxi_ipay88_backend"
                        console.log(this.ipay88PaymentRequest)
                        setTimeout(function () { 
                            const elem = this.$refs.submitIpay88
                            elem.click()
                        }.bind(this), 1500)
                    }else{
                        this.completeOrderLoading = false
                        this.errors = get_merchant_details["error"].split(",")
                    }
                }
            }
        },
        postDocument: async function(documentPayload,orderDetails){
            var create_documents = await HTTPRequest.postRequest(this.endPoint + 'documents', null, documentPayload)
            if (create_documents["error"] == undefined) {
                var update_order = await HTTPRequest.postRequest(this.endPoint + 'orders/update_document_line', null, {document_id:create_documents.id,order_id:orderDetails.id})
                this.orderResponse = update_order
                if (update_order["error"] == undefined){
                    if (this.paymayaPaymentStatus!=null && this.paymentMethod == 3){
                        var get_order_detail = await HTTPRequest.getRequest(this.endPoint+'orders/get_order_detail?order_id='+orderDetails.id,null)
                        var get_payments = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_paymaya_payments?checkoutId='+get_order_detail.reference, null)
                        if (get_payments["error"] == undefined){
                            get_payments["payment_url"]["requestReferenceNumber"] = create_documents.id
                            var paymaya_post_req = await HTTPRequest.postRequest(this.endPoint + 'paymaya_webhooks/success_hook', null, get_payments["payment_url"])
                            if (paymaya_post_req["error"] == undefined){
                                this.removePostedItem()
                            }
                        }
                    }else if(this.dragonpayPaymentdetails["status"]!=undefined && this.paymentMethod == 4){
                        this.dragonpayPaymentdetails["txnid"] = create_documents.id
                        this.dragonpayPaymentdetails["amount"] = orderDetails.totalAmount
                        this.dragonpayPaymentdetails["procId"] = this.paymentDragonpayMethod
                        var dragonpay_post_req = await HTTPRequest.postRequest(this.endPoint + 'dragonpay_webhooks/success_hook',null,this.dragonpayPaymentdetails)
                        if (dragonpay_post_req["error"] == undefined){
                            this.removePostedItem()
                        }
                    }else if (this.ipay88Paymentdetails["Status"]!=undefined && this.paymentMethod == 5){
                        this.ipay88Paymentdetails["DocId"] = create_documents.id
                        var ipay88_post_req = await HTTPRequest.postRequest(this.endPoint + 'ipay88_webhooks/success_hook',null,this.ipay88Paymentdetails)
                        console.log(ipay88_post_req)
                        if (ipay88_post_req["error"] == undefined){
                            this.removePostedItem()
                        }
                    }else{
                        this.removePostedItem()
                    }
                }else{
                    this.completeOrderLoading = false
                    this.errors = create_documents["error"].split(",")
                }
            } else {
                this.completeOrderLoading = false
                this.errors = create_documents["error"].split(",")
            }
        },
        getQueryParams(qs) {
            var vars = {};
            var parts = qs.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                vars[key] = value;
            });
            return vars;
        },
        removePostedItem: async function(){
            this.step = 4;
            this.$router.replace({name: 'checkout', params:{ storeId:this.$route.params.storeId }})
            var checkoutOrderData = secureStorage.getItem("CheckoutOrderListData"+this.storeDetails.name);
            var gData = []
            if(this.loginStatus){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_cart_items?account_id='+this.storeDetails.account_id+'&sales_channel_id='+this.storeDetails.id+'&customer_id='+this.CustomerDetailsLogin.id, null)
                gData = response;
                for(let i = 0; i < checkoutOrderData.length; i++){
                    var index = gData.findIndex(x=> x.product_id == checkoutOrderData[i].product_id)
                    if (index >=0){
                        if (checkoutOrderData[i].quantity < gData[index].quantity){
                            var quantity = gData[index].quantity - checkoutOrderData[i].quantity
                            var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +gData[index].sales_channel_cart_item_id, null, {quantity:quantity}) 
                        } else {
                            var response = await HTTPRequest.destroyRequest(this.endPoint + 'sales_channel_cart_items/'+gData[index].sales_channel_cart_item_id, null, null)
                        }
                    }
                }
            }else{
                gData = secureStorage.getItem("OrderListData"+this.storeDetails.name);
                for(let i = 0; i < checkoutOrderData.length; i++){
                    var index = gData.findIndex(x=> x.product_id == checkoutOrderData[i].product_id)
                    if (index >=0){
                        gData.splice(index,1)
                    }
                }
                secureStorage.setItem("OrderListData"+this.storeDetails.name,gData)
            }
            secureStorage.setItem("CheckoutOrderListData"+this.storeDetails.name,[]);
            if (this.paymentMethod == 3 || this.paymentMethod == 4 || this.paymentMethod == 5){
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-tempDocument",{})
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-orderResponse",{})
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-shippingMethod",null)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentMethod",null)
                this.paymentMethod == 4 ? secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-paymentDragonpayMethod",null) : ''
                this.paymentMethod == 5 ? secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-PaymentId",null) : ''
            }else{
            }
            this.completeOrderLoading = false
            this.paymentStatusLoading = false
        },
        totalShippingFee(){
            let total = 0
            if(this.shippingMethod==1){
                if(this.storeDetails.shipping_fee_option == 1){
                    total = parseFloat(this.storeDetails.shipping_fee)
                }else if (this.storeDetails.shipping_fee_option == 2){
                let qty = this.subtotal / parseFloat(this.storeDetails.shipping_fee_amount)
                total = parseFloat(this.storeDetails.shipping_fee) * parseFloat(qty)
                }
            }
            return total
        },
        getUserAddress:async function(){
            var response = await HTTPRequest.getRequest(this.endPoint + 'customer_addresses?email='+this.CustomerDetailsLogin.email+'&account_id='+this.storeDetails.account_id,null)
            console.log(response)
            if (response["error"]==undefined){
                this.addressListCount = response.length
                this.addressList = response
            }
        },
        getShippingMethod:async function(shipping_method_name,shipping_type){
            var shipping_method = await HTTPRequest.getRequest(this.endPoint + 'shipping_methods?name='+shipping_method_name+'&shipping_type='+shipping_type,null)
            if(shipping_method.data.length != 0){
                this.documentShippingMethodId = shipping_method.data[0].id
            }else {
                await this.createShippingMethod(shipping_method_name,shipping_type)
            }       
        },
        createShippingMethod:async function(shipping_method_name,shipping_type){
            var data = {
                shipping_method: {
                    name:shipping_method_name,
                    shipping_type:shipping_type
                }
            }
            var create_shipping_methods = await HTTPRequest.postRequest(this.endPoint + 'shipping_methods', null, data)
            if (create_shipping_methods["error"] == undefined) {
                this.documentShippingMethodId = create_shipping_methods.id
            }
        },
    }
};
</script>
<style scoped>
.product-thumbnail {
    width: 4.6em;
    height: 4.6em;
    border-radius: 8px;
    background: #fff;
    position: relative;
}
.product-thumbnail__image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
}
.breadcrumb-item + .breadcrumb-item::before {
    content: "›";
}
.custom-scrollbar-css::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.custom-scrollbar-css::-webkit-scrollbar-track {
    background: #eee;
}
.custom-scrollbar-css::-webkit-scrollbar-thumb {
    border-radius: 1rem;
    background-color: rgba(124, 124, 124, 0.6);
}
.v-lazy-image {
    filter: blur(10px);
    transition: filter 0.7s;
}
.v-lazy-image-loaded {
    filter: blur(0);
}
.selected-address{
    border: 2px solid #5e72e4!important;
    box-sizing: border-box!important;
    box-shadow: 0px 0px 8px rgb(94, 114, 228)!important;
    border-radius: 4px!important;
}
.white-space-inherit{
    white-space: inherit;
}
</style>
